import { render } from "./ForgeNotetaker.vue?vue&type=template&id=718a59a0&scoped=true&ts=true"
import script from "./ForgeNotetaker.vue?vue&type=script&lang=ts"
export * from "./ForgeNotetaker.vue?vue&type=script&lang=ts"

import "./ForgeNotetaker.vue?vue&type=style&index=0&id=718a59a0&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718a59a0"]])

export default __exports__